import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled, Text, TextTag, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { minimalScreenWidth } from '@/common/breakpoints';
const StyledLegalNotice = styled.section`
  width: 100%;
  display: flex;
  gap: ${(props) => props.theme.size.dynamic0020};
  padding-left: ${(props) => props.theme.size.dynamic0150};
  padding-right: ${(props) => props.theme.size.dynamic0150};
  padding-bottom: ${(props) => props.theme.size.dynamic0100};

  @media screen and ${minimalScreenWidth.l} {
    padding-left: ${(props) => props.theme.size.dynamic0250};
    padding-right: ${(props) => props.theme.size.dynamic0250};
    padding-bottom: ${(props) => props.theme.size.dynamic0150};
  }

  @media screen and ${minimalScreenWidth.xl} {
    padding-left: ${(props) => props.theme.size.dynamic0450};
    padding-right: ${(props) => props.theme.size.dynamic0450};
    padding-bottom: ${(props) => props.theme.size.dynamic0150};
  }
`;

export const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledLegalNotice data-testid="legal-notice">
      <Text tag={TextTag.p} appearance={TokenTextAppearance.label100}>
        <Text tag={TextTag.span} appearance={TokenTextAppearance.label100} bold>
          {t('legalNotice.heading')}
        </Text>{' '}
        <Text tag={TextTag.span} appearance={TokenTextAppearance.label100}>
          {t('legalNotice.description')}
        </Text>
      </Text>
    </StyledLegalNotice>
  );
};
